import { render, staticRenderFns } from "./vContract.vue?vue&type=template&id=3ddaec15&"
import script from "./vContract.vue?vue&type=script&lang=js&"
export * from "./vContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports